module.exports = __webpack_public_path__ + "static/media/usersSmallBig.2e1681fa.svg";